<template>
    <div class="kpi-card">
      <div class="chart-box">
        <!-- <pie-chart :value="percentage" :color="color" /> -->
        <i :class="icon" class="kpi-icon" :style="{ color }"></i>
      </div>
      <div class="kpi-text">
        <h3>{{ title }}</h3>
        <p>{{ animatedValue }}</p>
      </div>
    </div>
  </template>
  
  <script>
//   import PieChart from './PieChart.vue'
  
  export default {
    name: 'KPIItem',
    components: {  },
    props: {
      title: String,
      icon: String,
      value: Number,
      percentage: Number,
      color: String
    },
    data() {
      return {
        animatedValue: 0
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(newVal) {
          let start = 0
          const end = newVal
          const duration = 800
          const frameRate = 20
          const increment = (end - start) / (duration / frameRate)
  
          const interval = setInterval(() => {
            start += increment
            if (start >= end) {
              start = end
              clearInterval(interval)
            }
            this.animatedValue = Math.floor(start)
          }, frameRate)
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .kpi-card {
    flex: 1 1 30%;
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
    padding: 20px;
    display: flex;
    align-items: center;
    transition: transform 0.3s ease;
  }
  
  .kpi-card:hover {
    transform: translateY(-6px);
  }
  
  .kpi-icon {
    font-size: 36px;
    color: inherit;
  }
  
  .chart-box {
    width: 80px;
    height: 80px;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f4f4f4; /* optional: for better visual */
    border-radius: 50%;        /* optional: make it circular */
  }
  
  .kpi-text h3 {
    font-size: 16px;
    margin: 0;
    color: #666;
  }
  
  .kpi-text p {
    font-size: 28px;
    font-weight: bold;
    margin: 4px 0 0;
  }
  </style>
  